/**
 * Coming Soon Event form component
 * 
 * @module coming-soon-form
 * @version 1.0.0
 * @extends HTMLElement
 */
class comingSoonFormComponent extends HTMLElement {

    /**
     * Coming Soon Event form web component.
     * 
     * @constructor
     */
    constructor() {

        super();
        
        this.initEvents();
    }

    /**
     * Init events.
     * 
     * @returns {undefined}
     */
    initEvents() {

        window.dataLayer = window.dataLayer || [];

        window.addEventListener('load', () => {

            const comingSoonForm = this.querySelector('form');

            // Check form
            if(comingSoonForm) {

                comingSoonForm.addEventListener('submit', event => {
    
                    event.preventDefault();
                    const eventId = window.eventId ? this.capitalizeWords(window.eventId.replaceAll('-', ' ')) : 'Default Event ID';
                    const image = event.target.image_event ? event.target.image_event.value : '';
                    const eventMarket = event.target.market ? event.target.market.value : '';
                    const textField = event.target.text_field ? event.target.text_field.value : '';
                    const textField1 = event.target.text_field1 ? event.target.text_field1.value : '';
                    const email = event.target.email ? event.target.email.value : '';
                    const phone_number = event.target.phone ? event.target.phone.value : '';
                    const first_name = event.target.first_name ? event.target.first_name.value : '';
                    const last_name = event.target.last_name ? event.target.last_name.value : '';

                    let referringUrl;
                    let citySource = null;

                    if( typeof document['referrer'] !== 'undefined' ) { 
                        referringUrl = document.referrer;
                    } else {
                        referringUrl = "direct access";
                    }
    
                    // Check event ID
                    if(eventId) {

                        try {

                            var objProp = {
                                eventId: eventId,
                                referringUrl: referringUrl
                            }

                            if(event.target.checkbox && event.target.checkbox.checked) {
                                let checkbox = event.target.checkbox.placeholder;
                                    
                                objProp.checkbox = checkbox;                                
                            } 

                            if(event.target.checkbox1 && event.target.checkbox1.checked) {
                                let checkbox1 = event.target.checkbox1.placeholder;
                                    
                                objProp.checkbox = checkbox1;
                            } 
        
                            if(textField != ''){
                                objProp.textField = event.target.text_field.placeholder+ ' : ' + textField;
                            }

                            if(textField1 != ''){
                                objProp.textField1 = event.target.text_field1.placeholder + ' : ' + textField1;
                            }

                            if(eventMarket != ''){
                                objProp.market = eventMarket;
                            }

                            if(eventMarket != '') {
                                if(eventMarket.includes("New York") || eventMarket.includes("NY")) {
                                    citySource = "New York";
                                }
                                else if(eventMarket.includes("Miami") || eventMarket.includes("MIA")) {
                                    citySource = "Miami";
                                }
                                else if(eventMarket.includes("Los Angeles") || eventMarket.includes("LA")) {
                                    citySource = "Los Angeles";
                                }
                                else if(eventMarket.includes("Chicago") || eventMarket.includes("CHI")) {
                                    citySource = "Chicago";
                                }
                                else if(eventMarket.includes("Dallas") || eventMarket.includes("DAL")) {
                                    citySource = "Dallas";
                                }
                                else {
                                    citySource = "Online";
                                }
                            }

                            // Send event to data layer
                            window.dataLayer.push({
                                "event": "ComingSoonNotify",
                                "eventId": eventId,
                                "market": citySource,
                                "email": email,
                                "firstName": (event.target.first_name && event.target.first_name.value) || 'defaultFirstName',
                                "lastName": (event.target.last_name && event.target.last_name.value) || 'defaultLastName',
                                "referringUrl": referringUrl,
                                "phone_number": phone_number,
                                "image": image
                            });

                            // ---------------------- Bloomreach Events ----------------------
                            if(window.exponea) {

                                // Customer Tracking
                                exponea.identify(
                                    {
                                        email_id: email,
                                    },
                                    {
                                        first_name: event.target.first_name.value,
                                        last_name: event.target.last_name.value,
                                        email: email
                                    }
                                );

                                // Sign Up Event
                                exponea.track('sign_up_event', {
                                    event: "ComingSoonNotify",
                                    eventId: eventId,
                                    market: citySource,
                                    email: email,
                                    first_name: event.target.first_name.value,
                                    last_name: event.target.last_name.value,
                                    referringUrl: referringUrl,
                                    text_field: event.target.text_field !== undefined && textField !== '' ? event.target.text_field?.placeholder + ':' + event.target.text_field.value : '',
                                    phone_number: phone_number,
                                    image: image
                                });

                                // Consent Event - City
                                exponea.track('consent', {
                                    email: email,
                                    action: "accept",
                                    category: citySource, 
                                    valid_until: "unlimited",
                                    message: "Don't Miss Out! Sign-up for event notifications"
                                });

                                // Consent Event - Marketing
                                exponea.track('consent', {
                                    email: email,
                                    action: "accept",
                                    category: "Marketing", 
                                    valid_until: "unlimited",
                                    message: "Don't Miss Out! Sign-up for event notifications"
                                });

                                // Consent Event - SMS
                                exponea.track('consent', {
                                    email: email,
                                    action: "accept",
                                    category: "SMS", 
                                    valid_until: "unlimited",
                                    message: "Plus - receive event announcements like special promotions or additional discounts that happen throughout the week"
                                });

                                /* Shopify Consent Event
                                exponea.track('shopify_consent', {
                                    action: "accept",
                                    category: "Marketing", 
                                    valid_until: "unlimited"
                                });
                                */
                            }
                            
                        } finally {

                            this.showConfirmText()
                            
                            // Clear all fields
                            event.target.reset();

                            setTimeout(() => {
                                window.notifyFlyout.close();
                            }, 3500);
                        }

                    }
                });
            }
        } , false);
    }

    /**
    * Capitalize words
    * 
    * @returns {string}
    */
    capitalizeWords(str) {
        return str.replace(/\b\w/g, (match) => match.toUpperCase());
    }

    /**
     * Show confirmation message on form
     * 
     * @returns {undefined}
     */
     showConfirmText() {

        let confirmDiv = this.querySelector('[data-confirm-message]');

        if(confirmDiv) {
            confirmDiv.classList.add("success");
        }
    }
}

customElements.define('coming-soon-form', comingSoonFormComponent);